export const pickKeys = [
  'name',
  'price',
  'supplyPrice',
  'inventory',
  'inventoryAlertAmount',
  'sku',
  'tax',
  'category',
  'brand',
];

export const SET_TITLE = 'SET_TITLE';
export const SET_REPORT_TITLE = 'SET_REPORT_TITLE';
export const SET_PO_TITLE = 'SET_PO_TITLE';
export const SET_ECOM_TITLE = 'SET_ECOM_TITLE';

export const PRODUCT_DETAILS_STEP = 0;
export const PRODUCT_ASSIGNMENT_STEP = 1;
